export default {

	STATUSES: {
		ERROR: "error",
		ABORTED: "aborted",
		UPLOADING: "uploading",
		DONE: "uploaded",
	},
};
